import Image from "next/image";
import phone from "../../assets/images/upsc/phone.png";
import styles from "../upsc-prestorming-prelims-test-series/prestorming.module.css";
import NewiconA from "../../assets/images/header/pdf-download1.png";
import Link from "next/link";
const Prelims = () => {

  const feestructure3 =[ 

    // {center: "Coimbatore",mode: (<><div>Batch 2 - Regular</div><div>(Online & Offline)</div></>), start: "10th Oct 2025",
    //   cont3:(<Link href="https://www.shankariasacademy.com/pdf/UPSC-2026/prestorming-2026/AnnaNagar/Prestorming-B2-AnnaNagar-2026-27.pdf" target="_blank" className={`${styles.paybill}`}> 
    //             <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Download PDF</Link>),
    //     pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
    //                 <button className={`${styles.normalbutton1} btn btn-danger`}>
    //                   Pay Now
    //                 </button>
    //             </a>)
    //         }
    ];

  return (
    <>

<section  id="courseandfees">
    <div className="container pt-xl-4" >
      <div className="row">
         <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Center</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Batch</div>
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Starts on</div>
         <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#fee5d3" }}>Schedule</div> 
         <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#ffbdac" }}>Admission</div>
           <hr/>
      </div>
                    
      {feestructure3.map((item,index)=>(
        <div className={`${styles.facultyborder3} row`}>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-3`}>{item.center}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.mode}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 
            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                 <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
          {item.pay}
        </div>
          <hr/>
        </div>
      ))}      
    </div>  
</section>

<div className="container pt-2 pb-2">
  <p className={`${styles.acheiverrank1} pt-3 pb-2`}><span style={{color:"#e21111ff"}}>Note :</span> Prestorming Batch 1- 7th Sep (Only Annanagar)<sup className= {`${styles.dot1}`}>*</sup></p>
</div> 

<div className="container  py-3">
  <div className="row">
    <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
        <div className={`${styles.facultyborder3} p-4 h-100`}>
              <p className={`${styles.sectionsubtitle}`}>GS + CSAT</p>
              <div className="row">
                  <div className="col-lg-4 col-5 col-md-6">
                    <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,500/-</p>
                  </div>
                  <div className="col-lg-8 col-7 col-md-6">
                    <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                  </div>
              </div>

              <div className="row pt-3">
                  <div className="col-lg-4 col-5 col-md-6">
                    <p className={`${styles.sectionredtitle}`}><b>₹</b>8,500/-</p>
                  </div>
                  <div className="col-lg-8 col-7 col-md-6">
                    <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                  </div>
              </div>
        </div>
    </div>

    <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
      <div className={`${styles.facultyborder3} p-4 h-100`}>
          <p className={`${styles.sectionsubtitle}`}>GS</p>
          <div className="row">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle} mb-0`}><b>₹</b>9,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4 mb-0`}>New Students</p>
                </div>
          </div>
          <div className="row pt-3">
                <div className="col-lg-4 col-5 col-md-6">
                  <p className={`${styles.sectionredtitle}`}><b>₹</b>8,000/-</p>
                </div>
                <div className="col-lg-8 col-7 col-md-6">
                  <p className={`${styles.acheiverrank} px-xl-4`}>Old Students</p>
                </div>
          </div>
      </div>
    </div>

    <div className="col-md-6 col-xl-4 mb-3 mb-md-4 col-12">
      <div className={`${styles.facultyborder3} p-4 h-100`}>
        <p className={`${styles.sectionsubtitle}`}>CSAT</p>
        <div className="row">
          <div className="col-lg-4 col-5 col-md-6">
            <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
          </div>
        </div>
        {/* <div className="row">
            <div className="col-lg-4 col-5 col-md-6">
              <p className={`${styles.sectionredtitle}`}><b>₹</b>1,500/-</p>
            </div>
        </div> */}
      </div>
    </div>
  </div>
</div>

{/* ====== COIMBATORE CENTRE ADMISSION INSTRUCTIONS ====== 
<div className="container my-5">
  <div
    className="p-2 p-md-5 rounded-4 shadow-sm"
    style={{
      background: "linear-gradient(180deg, #f4f6f8, #fef5f5)",
      borderLeft: "5px solid #bf725e",
    }}
  >
    <h5
      className="fw-bold text-uppercase mb-3"
      style={{ color: "#ba141a", letterSpacing: "0.5px" }}
    >
      Coimbatore Centre Prestorming Admission Instructions
    </h5>
    <p className="mb-2 " style={{ lineHeight: "1.6" }}>
      Due to the shifting of our UPSC program to a new premises in Coimbatore, the exact venue details will be updated soon on our website.
    </p>

    <p className="mb-2 " style={{ lineHeight: "1.6" }}>
      Students who wish to take the Prestorming Test Series – Batch 2 in offline mode are
      requested to complete their admission by selecting either <strong>Anna Nagar</strong> or
      <strong> Online Test</strong> batch for now.
    </p>
    <p className="mb-2 " style={{ lineHeight: "1.6" }}>
      Offline tests will commence from <strong>Test 1</strong>, and recorded discussions will
      be provided. Alternatively, students may take the first three tests online until the
      <strong> Coimbatore Center – UPSC program</strong> becomes operational.
    </p>
    <p className="mb-2 " style={{ lineHeight: "1.6" , color:"#e21111ff"}}>
      For enquiries, kindly contact:
    </p>
    <p className="mb-0">
          📞  63816 77240 / 98898 98868 <br />
          ✉️ prestorming@shankarias.in / siaupsccoimbatore@shankariasacad.in
    </p>
  </div>
</div>*/}


 <div className="container py-2">
    <div className="row">
      <div className="col-lg-6  col-12">
        <div className={`${styles.prebg}`}>
          <h2 className={`${styles.aboutheading1}`}>UPSC-Coimbatore</h2>
          <p className={`${styles.acheiverrank1} ${styles.dark} mb-0`}><Image src={phone} alt="Shankar IAS Academy annanagar contact number" title="Contact number" className={`${styles.phoneiconcss} img-fluid pe-2`} /> <a href="tel: 0422-4380837" className={`${styles.numberbold}`}> </a> <b></b> <a href="tel:9994551898" className={`${styles.numberbold}`} >98898 98868</a> </p>
          <p className={`${styles.acheiverrank1} mb-0`}>Gayathri Building-2nd Floor,<br/>Old # 220B, New# 149B,<br/>Dr.Rajendraprasad Road (100 ft Road),<br/>  Landmark:Above Prince Jewellery <br/>Coimbatore - 641012</p>
          {/* {/* <p className={`${styles.acheiverrank1} mb-0`}>Next to Josco Jewellers Building,</p> 
          {/* <p className={`${styles.acheiverrank1} `}>Gandhipuram, Coimbatore - 641 012</p> 
          {/* <p className={`${styles.redunderline} `}><Link href="https://www.google.com/maps/place/SHANKAR+IAS+ACADEMY/@11.017169,76.9606007,19z/data=!4m6!3m5!1s0x3ba859706e95a5c1:0xbb2b1ddc6a6b45ad!8m2!3d11.017169!4d76.961521!15sChNzaGFua2FyIGlhcyBhY2FkZW15IgOIAQGSARBlZHVjYXRpb25fY2VudGVy4AEA?hl=en&coh=164777&entry=tt&shorturl=1" rel="noreferrer" target="_blank" className={`${styles.redunderlinealink}`}>Get Direction</Link></p>  */}
        </div>
      </div>
    </div>
</div> 

    </>
  );
};

export default Prelims;